import { render } from "./SpinnerComp.vue?vue&type=template&id=397a0f5c"
const script = {}

import "./SpinnerComp.vue?vue&type=style&index=0&id=397a0f5c&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__